import TransfersListModel from "./model";
import styled from "styled-components";

const TransfersList = styled(TransfersListModel)`
  #root & {
  }
`;

export default TransfersList;
